<template>
  <v-app>
    <!-- Headers -->
    <v-content class="px-2">
      <v-container fill-height>
        <v-layout column align-center justify-center>
          <h1 :style="{color:kiwiGreen}">404 Resource Not Found</h1>
          <v-btn dark :color="coalBlack" class="ml-0" :to="redirectPath">Back</v-btn>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { get } from 'vuex-pathify';
export default {
  computed: {
    user: get('user'),
    redirectPath() {
      if (this.user) {
        return 'dashboard/home';
      }
      return '/';
    },
  },
};
</script>
